import { Injectable } from "@angular/core";
import moment from "moment";

@Injectable({ providedIn: 'root'})
export class HandleDates {
  private isIsoDateString(value: any): { valid: boolean, value?: Date } {

    if (value && typeof value === "string") {
      let m = moment(value, [moment.HTML5_FMT.DATE, moment.HTML5_FMT.DATETIME_LOCAL_SECONDS, "YYYY-MM-DDTHH:mm:ssZ"], true);
      if (m.isValid()) {
        return { valid: true, value: m.toDate() };
      }
    }
    return { valid: false };
  }

  public handleDates(body: any) {
    if (body === null || body === undefined || typeof body !== "object")
      return body;

    for (const key of Object.keys(body)) {
      const value = body[key];
      let isDate = this.isIsoDateString(value);
      if (isDate.valid) body[key] = isDate.value;
      else if (typeof value === "object") this.handleDates(value);
    }
    return body;
  }
}